import { useContext } from "react";

import { Button, Buttons, Tag } from "capitalrx-components-2.0/lib/general";
import { Grid, Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading, Subheading } from "capitalrx-components-2.0/lib/typography";

import { PageLayout } from "@/premium/themedComponents";
import { EnrollmentContext } from "@/state/context";
import { PlanCard } from "@/common/components";
import { useNavigateSearch } from "@/premium/hooks";
import { StackOrShelf } from "@/common/components/StackOrShelf";
import { useTranslation } from "react-i18next";
import { enablePlansPageRedesign } from "@/utils/featureFlags";

export const PlansPage = () => {
  const [state, _] = useContext(EnrollmentContext);
  const { t: translate } = useTranslation();
  const navigateSearch = useNavigateSearch();
  const plans = state.experienceData.plan_csids;
  const { columns } = useResponsive({
    columns: {
      mobile: 12,
      tablet: 6,
      desktop: 6,
    },
  });

  const handlePlanCardClick = (id: number) => {
    if (!enablePlansPageRedesign()) {
      navigateSearch("/plan", {
        enrollmentPlan: id,
      });
    } else {
      navigateSearch("/plan-details", {
        enrollmentPlan: id,
      });
    }
  };

  return (
    <PageLayout showGradient={false}>
      <Stack>
        <Stack spacing="small">
          <Heading>{translate("PLAN_PAGE.plans")}</Heading>
          <Body>{translate("PLAN_PAGE.planPageDescription")}</Body>
        </Stack>
        <StackOrShelf>
          <Button appearance={Buttons.Functional.Tertiary.Large} icon="filter">{translate("PLAN_PAGE.filter")}</Button>
          <Shelf.Spacer />
        </StackOrShelf>
        <Grid>
          {
            plans?.length > 0 && plans.map((plan) => {
              return (
                <Grid.Span columns={columns} key={plan.rn}>
                  <PlanCard onClick={() => handlePlanCardClick(plan.id)}>
                    <Stack spacing="mini">
                      <Subheading>{plan.display_name}</Subheading>
                      <Shelf spacing="mini" responsive="wrap" responsiveAlignment="left">
                        {
                          ["ABCD", "EFGH", "ABCD", "EFGH", "ABCD", "EFGH", "EFGH", "ABCD", "EFGH"].map((filter, index) => <Tag key={`${filter}-${index}`}>{filter}</Tag>)
                        }
                      </Shelf>
                    </Stack>
                  </PlanCard>
                </Grid.Span>
              );
            })
          }
        </Grid>
      </Stack>
    </PageLayout>
  );
};
